(function () {
  'use strict';

  function initRoot(root) {
    if (root.dataset.dtsInit === '1') return;
    root.dataset.dtsInit = '1';

    var panels = root.querySelectorAll('[data-dts-panel]');
    var dots = root.querySelectorAll('[data-dts-dot]');
    var slideGroups = [];

    panels.forEach(function (panel) {
      slideGroups.push(panel.querySelectorAll('[data-dts-slide]'));
    });

    // Card alignment from select value ("justify items")
    var grid = root.querySelector('.dts-grid');
    var alignAttr = (grid && grid.getAttribute('style')) || '';
    var alignMatch = alignAttr.match(/--dts-card-align:\s*([^;]+)/);
    if (alignMatch) {
      var parts = alignMatch[1].trim().split(/\s+/);
      var justify = parts[0] || 'flex-end';
      var items = parts[1] || 'center';
      root.style.setProperty('--dts-card-justify', justify);
      root.style.setProperty('--dts-card-items', items);
      root.style.setProperty('--dts-btn-self', items);
    }

    var count = slideGroups.length ? slideGroups[0].length : 0;
    if (count <= 1) return; // nothing to rotate

    var interval = (parseFloat(root.dataset.interval) || 5) * 1000;
    var autoplay = root.dataset.autoplay === 'true';
    var pauseOnHover = root.dataset.pauseOnHover === 'true';
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer = null;

    function setSlide(index) {
      index = ((index % count) + count) % count;
      slideGroups.forEach(function (group) {
        group.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          // pause non-active videos, play active to keep them in sync & save CPU
          var vid = slide.querySelector('video');
          if (vid) {
            if (active) {
              var p = vid.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              try { vid.pause(); } catch (e) {}
            }
          }
        });
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      current = index;
    }

    function next() { setSlide(current + 1); }

    function start() {
      if (!autoplay || prefersReduced || timer) return;
      timer = setInterval(next, interval);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function restart() { stop(); start(); }

    // Dots
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.dtsDot, 10);
        if (!isNaN(idx)) { setSlide(idx); restart(); }
      });
    });

    // Pause on hover (desktop) — only when enabled in the theme editor
    if (pauseOnHover) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
    }

    // Pause when tab hidden (always, to save CPU and keep slides in sync)
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    // Pause when offscreen
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) start(); else stop();
        });
      }, { threshold: 0.2 });
      io.observe(root);
    }

    setSlide(0);
    start();
  }

  function initAll() {
    document.querySelectorAll('[data-dts-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-dts-root]');
    if (root) { root.dataset.dtsInit = ''; initRoot(root); }
  });
})();